module.exports = __webpack_public_path__ + "static/media/deer.1279ea64.jpg";